/*
 * BONSAI MOTO 商品説明のアコーディオン（旧サイトの挙動を再現）
 *
 * 旧サイト（ショップサーブ）では、テーマ側の /js/product.js が
 * `.description__item .pulldown` をクリック → 次の兄弟要素（.description__item__inner）を
 * 高さ＋不透明度 0.3s で開閉していた。商品説明HTMLは移行時にそのままShopifyの
 * 本文へ入っている（178商品・695項目）ため、失われているのはこの挙動だけ。
 * → 商品データは触らず、テーマ側でJSとCSSを用意して再現する。
 *
 * 設計上の決めごと:
 *  - 初期非表示は `html.bonsai-acc-on` が付いている時だけ効かせる（CSS側）。
 *    このクラスは main-product.liquid のインラインscriptが先に付け、
 *    ①本ファイルの初期化が例外で落ちた場合 ②本ファイルが読めなかった場合
 *    のいずれでも外れる。＝ JSが動かない時は「全部開いた状態」で止まり、本文は消えない。
 *  - `.description__item` の外にある単独の `<p class="pulldown">`（21箇所・
 *    【インストール動画】等）は旧サイトでもただの見出しなので、対象にしない。
 *  - 矢印とカーソルは JS が付ける `aria-expanded` を条件にしている（CSS側）ため、
 *    初期化をスキップした項目が「押せそうに見えるのに押せない」状態にならない。
 *  - PC（750px以上）で「下ではなく上へ開く」現象は、商品情報カラムの
 *    `position: sticky`（.product__column-sticky）が原因だった。JS側でスクロールを
 *    追従させる案は動きが不自然になったため取り下げ、bonsai-custom.css で
 *    このカラムのstickyを無効にして解消している（旧サイトも非sticky）。
 *    ここでは何もしない＝ただ下に開くだけ。
 */
(function () {
  'use strict';

  var DURATION = 300; // ms（旧サイト product.js の 0.3s と同値）
  var seq = 0;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setState(item, trigger, inner, open, animate) {
    trigger.classList.toggle('active', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);

    // 連打で前のアニメーションが残らないようにする
    window.clearTimeout(inner.bonsaiTimer);

    if (!animate) {
      inner.style.transition = '';
      inner.style.overflow = '';
      inner.style.height = '';
      inner.style.opacity = '';
      inner.style.display = open ? 'block' : 'none';
      return;
    }

    var from, to;
    if (open) {
      inner.style.display = 'block';
      from = '0px';
      to = inner.scrollHeight + 'px';
    } else {
      from = inner.scrollHeight + 'px';
      to = '0px';
    }

    inner.style.overflow = 'hidden';
    inner.style.transition = 'none';
    inner.style.height = from;
    inner.style.opacity = open ? '0' : '1';
    void inner.offsetHeight; // 強制リフロー（ここが無いと開始値が効かない）
    inner.style.transition = 'height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
    inner.style.height = to;
    inner.style.opacity = open ? '1' : '0';

    // transitionend は発火しないことがあるのでタイマーで確実に後始末する
    inner.bonsaiTimer = window.setTimeout(function () {
      inner.style.transition = '';
      inner.style.overflow = '';
      inner.style.height = '';
      inner.style.opacity = '';
      inner.style.display = open ? 'block' : 'none';
    }, DURATION + 50);
  }

  function bind(item) {
    if (item.dataset.bonsaiAccordion === 'ready') return true;

    var trigger = item.querySelector('.pulldown');
    if (!trigger) return false;
    var inner = trigger.nextElementSibling;
    if (!inner) return false;

    item.dataset.bonsaiAccordion = 'ready';

    if (!inner.id) {
      seq += 1;
      inner.id = 'bonsai-acc-' + seq;
    }
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-controls', inner.id);

    setState(item, trigger, inner, false, false);

    var toggle = function () {
      var open = trigger.getAttribute('aria-expanded') !== 'true';
      setState(item, trigger, inner, open, !prefersReducedMotion());
    };

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        toggle();
      }
    });

    return true;
  }

  function init(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.product__description .description__item');

    Array.prototype.forEach.call(items, function (item) {
      if (bind(item)) return;
      // 構造が想定と違って初期化できなかった項目は、隠れたままにしない
      Array.prototype.forEach.call(item.querySelectorAll('.description__item__inner'), function (inner) {
        inner.style.display = 'block';
      });
    });
  }

  function boot(root) {
    try {
      init(root);
      window.__bonsaiAccordionReady = true;
    } catch (error) {
      // 折りたたみ自体をやめる＝本文が読めなくなる状態を作らない
      document.documentElement.classList.remove('bonsai-acc-on');
      console.error('[BONSAI] 商品説明アコーディオンの初期化に失敗しました', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // テーマエディタでセクションを編集した直後にも効かせる
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
